import React, { useState, useCallback } from "react";
import { Divider, spacing, colors } from "../library";
import DownloadsItemContainer from "./DownloadsItemContainer";
import { css } from "glamor";
import { Icon } from "semantic-ui-react";
import ContentWithTooltip from "../library/ContentWithTooltip";

const downloadLinksTitleStyle = {
  fontSize: 16,
  color: colors.greyDarker,
  fontWeight: "bold",
};

const downloadLinksContainer = css({
  marginTop: spacing.m,
});

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
};

const iconStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: 0,
};

const subSectionClass = css({
  marginTop: spacing.s,
});

export default function DownloadsSection({
  title = "Downloads",
  hint,
  files,
  alwaysOpen = false,
}) {
  const [open, setOpen] = useState(alwaysOpen ? true : false);
  const handleToggleClick = useCallback(() => {
    if (alwaysOpen) return setOpen(true);

    setOpen(!open);
  }, [alwaysOpen, open]);

  if (files.length === 0) return null;

  return (
    <div className={downloadLinksContainer}>
      <div style={headerStyle} onClick={handleToggleClick}>
        {hint ? (
          <ContentWithTooltip
            content={<p style={downloadLinksTitleStyle}>{title}</p>}
            popupText={hint}
          />
        ) : (
          <p style={downloadLinksTitleStyle}>{title}</p>
        )}

        {!alwaysOpen && (
          <Icon style={iconStyle} name={open ? "chevron up" : "chevron down"} />
        )}
      </div>
      <Divider />

      {open && files.length > 0 && (
        <div className={subSectionClass}>
          {files.map((file, index) => (
            <DownloadsItemContainer key={file.id || index} file={file} index={index} />
          ))}
        </div>
      )}
    </div>
  );
}
